"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _sharedHeaderContract = require("@icis/shared-header-contract");
var _SubMenuWithIframe = require("./SubMenuWithIframe.styles");
var _SubMenuWithIframe2 = _interopRequireDefault(require("./SubMenuWithIframe.skeleton"));
const SubMenuWithIframeRender = _ref => {
  let {
    showing,
    url,
    iframeTitle,
    width,
    height,
    testId,
    isMobile,
    hasHeader,
    shouldAutoResize,
    isTopicsMenu = false
  } = _ref;
  const [showSpinner, setShowSpinner] = (0, _react.useState)(true);
  const [autoResize, shouldResize] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    if (!showing && !showSpinner) {
      setShowSpinner(true);
    }
  }, [showing, showSpinner]);
  (0, _react.useEffect)(() => {
    const unsubscribeChildLoad = (0, _sharedHeaderContract.subscribeToChildLoadChanges)(() => {
      shouldResize(true);
      (0, _sharedHeaderContract.sendScreenSizeToChild)({
        width: window.innerWidth,
        height: window.innerHeight,
        isMobileView: !!isMobile
      }, document.getElementById('sh-iframe-resizer'));
      setShowSpinner(false);
    });
    return () => {
      unsubscribeChildLoad();
    };
  }, [isMobile]);
  (0, _react.useEffect)(() => {
    if (!showing && autoResize) {
      shouldResize(false);
    }
  }, [showing, autoResize]);
  if (!showing) return null;
  const iframeProps = !isMobile ? {
    ...(isTopicsMenu ? {
      sizeWidth: true,
      widthCalculationMethod: 'taggedElement'
    } : {
      maxWidth: width,
      minWidth: width,
      maxHeight: height
    }),
    autoResize: !!shouldAutoResize,
    // False means iframe-resizer will only resize once on open and not when content scrolls
    sizeHeight: true,
    heightCalculationMethod: 'taggedElement'
  } : {
    autoResize: false,
    sizeHeight: false
  };
  return /*#__PURE__*/_react.default.createElement(_SubMenuWithIframe.IFrameContainer, {
    hasBg: showSpinner,
    height: showSpinner || !autoResize ? height : undefined,
    width: showSpinner || !autoResize ? width : undefined,
    isMobile: isMobile,
    hasHeader: hasHeader
  }, /*#__PURE__*/_react.default.createElement(_SubMenuWithIframe.IframeStyle, Object.assign({
    id: "sh-iframe-resizer",
    src: url,
    scrolling: true,
    width: showSpinner ? '0' : '100%',
    height: showSpinner ? '0' : '100%',
    allowTransparency: true,
    title: iframeTitle
  }, iframeProps)), showSpinner && /*#__PURE__*/_react.default.createElement(_SubMenuWithIframe2.default, {
    testId: testId
  }));
};
var _default = exports.default = SubMenuWithIframeRender;